// extracted by mini-css-extract-plugin
export default {"root":"ECXGUF","reviewsCount":"Skjb9m","thumbCount":"cP2QDx","startBlock":"HnfIAs","topPreloader":"W9Ob07","bottomPreloader":"pY0xNx"};